import { ComponentView } from "binder";
import { getAsBoolean } from "../../../utilities";
import { DateFilterViewModel } from "./dateFilter-viewModel"

export class DateFilterView extends ComponentView<DateFilterViewModel>{
    GetViewUniqueId(): string {
        return "V-FAEE104B-672F-493F-A6E0-4B7BB5372E1E"
    }
    loadHtml(): string {
        let element = require('./dateFilter.html').default;
        let style = require('./dateFilter.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isActive(v: boolean) { this._isActive =getAsBoolean(v); } public get isActive(): boolean { return this._isActive;} private _isActive: boolean;
    public set largerThan(v: moment.Moment) { this._largerThan = v; } public get largerThan(): moment.Moment { return this._largerThan;} private _largerThan: moment.Moment;
    public set smallerThan(v: moment.Moment) { this._smallerThan = v; } public get smallerThan(): moment.Moment { return this._smallerThan;} private _smallerThan: moment.Moment;
    public set applylarger(v: boolean) { this._applylarger =getAsBoolean(v); } public get applylarger(): boolean { return this._applylarger;} private _applylarger: boolean;
    public set applySmaller(v: boolean) { this._applySmaller =getAsBoolean(v); } public get applySmaller(): boolean { return this._applySmaller;} private _applySmaller: boolean;
    apply(){
        this.isActive = true;
        this.dataContext.apply();
    }
    removeFilter(){
        this.isActive = false;
        this.dataContext.apply();
    }
}
